import asyncActionType from "../../Utils/reduxActions";

const BULK_ANALYSE_ACTIONS = {
  ACTIVE: asyncActionType("[VERTEX360]BULK_ANALYSE_ACTIVE"),
  ACTIVE_CALL: "[VERTEX360]BULK_ANALYSE_ACTIVE_CALL",

  PREVIEW: asyncActionType("[VERTEX360]BULK_ANALYSE_PREVIEW"),
  PREVIEW_CALL: "[VERTEX360]BULK_ANALYSE_PREVIEW_CALL",

  CREATE: asyncActionType("[VERTEX360]BULK_ANALYSE_CREATE"),
  CREATE_CALL: "[VERTEX360]BULK_ANALYSE_CREATE_CALL",

  DETAIL: asyncActionType("[VERTEX360]BULK_ANALYSE_DETAIL"),
  DETAIL_CALL: "[VERTEX360]BULK_ANALYSE_DETAIL_CALL",

  STOP: asyncActionType("[VERTEX360]BULK_ANALYSE_STOP"),
  STOP_CALL: "[VERTEX360]BULK_ANALYSE_STOP_CALL",

  RETRY: asyncActionType("[VERTEX360]BULK_ANALYSE_RETRY"),
  RETRY_CALL: "[VERTEX360]BULK_ANALYSE_RETRY_CALL",

  DISMISS: asyncActionType("[VERTEX360]BULK_ANALYSE_DISMISS"),
  DISMISS_CALL: "[VERTEX360]BULK_ANALYSE_DISMISS_CALL",

  PUSHER_RECEIVED: "[VERTEX360]BULK_ANALYSE_PUSHER_RECEIVED",
  POLL_START: "[VERTEX360]BULK_ANALYSE_POLL_START",
  POLL_STOP: "[VERTEX360]BULK_ANALYSE_POLL_STOP",
  SET_JOB_OPEN: "[VERTEX360]BULK_ANALYSE_SET_JOB_OPEN",
  CLEAR_CREATE_ERROR: "[VERTEX360]BULK_ANALYSE_CLEAR_CREATE_ERROR",
  RESET: "[VERTEX360]BULK_ANALYSE_RESET",
};

export const getBulkAnalyseActive = {
  pending: { type: BULK_ANALYSE_ACTIONS.ACTIVE.PENDING },
  success: (data) => ({ type: BULK_ANALYSE_ACTIONS.ACTIVE.SUCCESS, data }),
  error: (error) => ({ type: BULK_ANALYSE_ACTIONS.ACTIVE.ERROR, error }),
};

/** Latest run for the organisation — restores the status bar after refresh or login. */
export const getBulkAnalyseActiveRequest = () => ({
  type: BULK_ANALYSE_ACTIONS.ACTIVE_CALL,
});

export const getBulkAnalysePreview = {
  pending: { type: BULK_ANALYSE_ACTIONS.PREVIEW.PENDING },
  success: (data) => ({ type: BULK_ANALYSE_ACTIONS.PREVIEW.SUCCESS, data }),
  error: (error) => ({ type: BULK_ANALYSE_ACTIONS.PREVIEW.ERROR, error }),
};

export const getBulkAnalysePreviewRequest = (payload) => ({
  type: BULK_ANALYSE_ACTIONS.PREVIEW_CALL,
  payload,
});

export const createBulkAnalyse = {
  pending: { type: BULK_ANALYSE_ACTIONS.CREATE.PENDING },
  success: (data) => ({ type: BULK_ANALYSE_ACTIONS.CREATE.SUCCESS, data }),
  error: (error) => ({ type: BULK_ANALYSE_ACTIONS.CREATE.ERROR, error }),
};

/** payload: { filters, leave_out_already_analysed, idempotency_key } */
export const createBulkAnalyseRequest = (payload) => ({
  type: BULK_ANALYSE_ACTIONS.CREATE_CALL,
  payload,
});

export const getBulkAnalyseDetail = {
  pending: { type: BULK_ANALYSE_ACTIONS.DETAIL.PENDING },
  success: (data) => ({ type: BULK_ANALYSE_ACTIONS.DETAIL.SUCCESS, data }),
  error: (error) => ({ type: BULK_ANALYSE_ACTIONS.DETAIL.ERROR, error }),
};

/** payload: { uuid, status, page } */
export const getBulkAnalyseDetailRequest = (payload) => ({
  type: BULK_ANALYSE_ACTIONS.DETAIL_CALL,
  payload,
});

export const stopBulkAnalyse = {
  pending: { type: BULK_ANALYSE_ACTIONS.STOP.PENDING },
  success: (data) => ({ type: BULK_ANALYSE_ACTIONS.STOP.SUCCESS, data }),
  error: (error) => ({ type: BULK_ANALYSE_ACTIONS.STOP.ERROR, error }),
};

export const stopBulkAnalyseRequest = (uuid) => ({
  type: BULK_ANALYSE_ACTIONS.STOP_CALL,
  payload: { uuid },
});

export const retryBulkAnalyse = {
  pending: { type: BULK_ANALYSE_ACTIONS.RETRY.PENDING },
  success: (data) => ({ type: BULK_ANALYSE_ACTIONS.RETRY.SUCCESS, data }),
  error: (error) => ({ type: BULK_ANALYSE_ACTIONS.RETRY.ERROR, error }),
};

export const retryBulkAnalyseRequest = (uuid, scope = "all") => ({
  type: BULK_ANALYSE_ACTIONS.RETRY_CALL,
  payload: { uuid, scope },
});

export const dismissBulkAnalyse = {
  pending: { type: BULK_ANALYSE_ACTIONS.DISMISS.PENDING },
  success: (data) => ({ type: BULK_ANALYSE_ACTIONS.DISMISS.SUCCESS, data }),
  error: (error) => ({ type: BULK_ANALYSE_ACTIONS.DISMISS.ERROR, error }),
};

export const dismissBulkAnalyseRequest = (uuid) => ({
  type: BULK_ANALYSE_ACTIONS.DISMISS_CALL,
  payload: { uuid },
});

/** bulk_analyse_updated / bulk_analyse_finished from role-sp-{sp_id}. */
export const bulkAnalysePusherReceived = (data) => ({
  type: BULK_ANALYSE_ACTIONS.PUSHER_RECEIVED,
  data,
});

export const startBulkAnalysePoll = () => ({ type: BULK_ANALYSE_ACTIONS.POLL_START });

export const stopBulkAnalysePoll = () => ({ type: BULK_ANALYSE_ACTIONS.POLL_STOP });

export const setBulkAnalyseJobOpen = (open) => ({
  type: BULK_ANALYSE_ACTIONS.SET_JOB_OPEN,
  open: Boolean(open),
});

export const clearBulkAnalyseCreateError = () => ({
  type: BULK_ANALYSE_ACTIONS.CLEAR_CREATE_ERROR,
});

export const resetBulkAnalyse = () => ({ type: BULK_ANALYSE_ACTIONS.RESET });

export default BULK_ANALYSE_ACTIONS;
